<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">	    			
			<h1>
				Smart List: Latent Physicians
				<span class="d-none d-md-inline text-transform-none font-weight-normal" style="letter-spacing:0;">(25 highest-rated by Referrer Score and no checkins in 6 months)</span>
			</h1>
			<div class="page-with-title">
				<physician-map-and-table
					v-if="data_loaded"
					:physician_data="physicians"
					:client_metrics="user.client.client_metrics ? user.client.client_metrics : null"
					:default_latitude="user.client.latitude ? parseFloat(user.client.latitude) : null"
					:default_longitude="user.client.longitude ? parseFloat(user.client.longitude) : null"
					default_sort_field="generated_charges"
					default_sort_direction="asc"
					default_per_page="50"
					:data_loaded="data_loaded"
				/>
			</div>
		</div>
	</div>
</div>
</template>

<script>
    import { mapState } from 'vuex'
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				physicians: [],
				data_loaded: false,
			}
		},

		created() {
			this.fetchPhysicians();			
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Providers', to: { name: 'physicians.list'} },
                { text: 'Smart Lists', to: { name: 'smart_lists.index'} },
                { text: 'Latent Physicians', to: { name: 'smart_lists.latent'} },
            ]);  
        },

		methods: {
			fetchPhysicians() {
				axios.get('/api/physicians/smart-lists/latent').then(({data}) => {
                    this.physicians = data;
                    this.data_loaded = true;
                });
				
			}
		},

		computed: mapState(['user'])
	}
</script>